import queryString from 'query-string';
import http from '../httpConfig';
import { List, AddEditApi, ChangePasswordApi } from '../interfaces/user.interface';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { buildPagingResponse } from '../utils/methods';

const list = (payload: List) => {
  const { searchText, role, status, stateId, cityId, areaUserIds, ...others } = payload;
  const paging = buildPagingResponse(others);
  const url = `${API_ENDPOINTS.listUsers}?${queryString.stringify(paging)}`;
  return http.post(url, {
    search: searchText,
    role_id: role,
    is_active: status,
    state_id: stateId,
    city_ids: Array.isArray(cityId) ? cityId.map(Number) : [],
    area_user_ids: Array.isArray(areaUserIds) ? areaUserIds.map(Number) : [],
  });
};

const managersLookup = (_payload: any) => {
  // Mock data
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve([
        { id: 1, name: 'John Doe', email: 'john.doe@example.com' },
        { id: 2, name: 'Jane Smith', email: 'jane.smith@example.com' },
        { id: 5, name: 'Charlie Brown', email: 'charlie.brown@example.com' },
      ]);
    }, 500);
  });

  // const url = `${API_ENDPOINTS.lookupManagers}?${queryString.stringify({ search: payload.searchText, is_active: payload.is_active })}`;
  // return http.get(url);
};

const add = (payload: AddEditApi | FormData) => {
  return http.post(API_ENDPOINTS.addUser, payload, {
    headers: { 'Content-Type': undefined }
  });
};

const edit = (id: string, payload: AddEditApi | FormData) => {
  return http.post(`${API_ENDPOINTS.editUser}/${id}`, payload, {
    headers: { 'Content-Type': undefined }
  });
};

const changePassword = (_payload: ChangePasswordApi) => {
  // Mock data
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        message: 'Password changed successfully',
      });
    }, 500);
  });

  // return http.post(API_ENDPOINTS.changePassword, payload);
};

const get = (id: string) => {
  return http.get(`${API_ENDPOINTS.getUser}/${id}`);
};

const kpis = () => {
  return http.get(API_ENDPOINTS.userListKpis);
};

const lookup = (payload: {
  searchText: string;
  exclude?: string;
  exclude_id?: string;
  is_active?: string;
}) => {
  const url = `${API_ENDPOINTS.lookupUsers}?${queryString.stringify({ search: payload.searchText || '', exclude: payload.exclude, exclude_id: payload.exclude_id, is_active: payload.is_active })}`;
  return http.get(url);
};

const deleteProfileImage = (id: string | number) => {
  return http.delete(`${API_ENDPOINTS.addUser}/${id}/profile-image`);
};

const deleteCompanyLogo = (id: string | number) => {
  return http.delete(`${API_ENDPOINTS.addUser}/${id}/company-logo`);
};

const UserService = {
  list,
  managersLookup,
  add,
  edit,
  changePassword,
  get,
  kpis,
  lookup,
  deleteProfileImage,
  deleteCompanyLogo,
};

export default UserService;
